import FormModal from "../../Modals/FormModal";
import { useCashRegister } from "../../../hooks/cash/useCashRegister";

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

const CashRegisterViewPopup = ({ isOpen, onClose }: Props) => {

  const { selected } = useCashRegister();

  if (!selected) return null;

  return (
    <FormModal
      isOpen={isOpen}
      onClose={onClose}
      title="Detalle de Terminal POS"
      maxWidth="max-w-2xl"
      overlayBg="black"
      zIndex="front"
    >

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">

        <div>
          <p className="text-gray-500">Nombre</p>
          <p className="font-medium">{selected.name}</p>
        </div>

        <div>
          <p className="text-gray-500">Código</p>
          <p className="font-medium">{selected.code}</p>
        </div>

        <div>
          <p className="text-gray-500">Sucursal</p>
          <p className="font-medium">{selected.branchName}</p>
        </div>

        <div>
          <p className="text-gray-500">Estado</p>
          <p className="font-medium">
            {selected.active ? "Activa" : "Inactiva"}
          </p>
        </div>

      </div>

    </FormModal>
  );
};

export default CashRegisterViewPopup;